import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { Chart, PammChartFilters } from '../../types';

dayjs.extend(utc);

export const DEFAULT_PAMM_CHART_FILTERS: PammChartFilters = {
  pammId: undefined,
  from: dayjs().utc().startOf('day').subtract(6, 'day').toISOString(),
  to: dayjs().utc().endOf('day').toISOString(),
};

export const charts: Chart[] = [
  {
    dataKey: 'amount',
    type: 'area',
  },
];
